module.exports = __webpack_public_path__ + "components/flag/static/square/sm-552324f90590bed4b94f74a5450c2bbc.svg";